export default "__VITE_ASSET__QkPj9Vfv__"